import type { GroupAnalysisData } from '@/generated/types/navigator/types.gen';
import CustomListBadgeLink from './CustomListBadgeLink';
import { Flex, ScrollArea } from '@mantine/core';
import { matchPath } from 'react-router-dom';
import { LISTS_DETAIL_PATH, LISTS_SPAN_PATH } from '@/app/constants';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';

export default function CustomListScroller({ a }: { a: GroupAnalysisData }) {
  const { id } =
    matchPath(LISTS_DETAIL_PATH, window.location.pathname)?.params ||
    matchPath(LISTS_SPAN_PATH, window.location.pathname)?.params ||
    {};

  const filteredLists = (a.lists ?? []).filter(
    (list): list is typeof list & { id: string } =>
      list.id != null && list.id !== id
  );

  if (filteredLists.length > 0) {
    return (
      <ScrollArea
        type="hover"
        offsetScrollbars="x"
        px="md"
        scrollHideDelay={200}
      >
        <Flex gap="md">
          {filteredLists.map((list) => (
            <CustomListBadgeLink
              key={list.id}
              listId={list.id}
              name={list.name ?? ''}
              onClick={() => {
                TagManager.dataLayer({
                  dataLayer: {
                    event: GoogleEvents.projects.entry.mapListAffordance,
                  },
                });
              }}
            />
          ))}
        </Flex>
      </ScrollArea>
    );
  }
}
